"use client";

import { useLingui } from "@lingui/react/macro";
import { AccessibleIcon } from "@offstreetparking/design-system/accessibility";
import { radioCardStyles } from "@offstreetparking/design-system/forms";
import { ChevronRightIcon } from "@offstreetparking/design-system/icons/ChevronRightIcon";
import { Heading, Text } from "@offstreetparking/design-system/typography";
import { classNames } from "@offstreetparking/design-system/utils";
type ItemStepProps = {
	permitTypes: Array<{
		id: number;
		name: string;
	}>;
	registrationSettings: Array<{
		id: number;
		name: string;
	}>;
	onSelectPermitType: (id: number, name: string) => void;
	onSelectRegistrationSetting: (id: number, name: string) => void;
};
export const ItemStep = ({
	permitTypes,
	registrationSettings,
	onSelectPermitType,
	onSelectRegistrationSetting,
}: ItemStepProps) => {
	const { t } = useLingui();
	return (
		<div className="space-y-4 p-8">
			<Heading>{t`Select Item`}</Heading>

			<ul className="flex flex-col gap-2">
				{permitTypes.map((pt) => (
					<li key={`pt-${pt.id}`}>
						<button
							type="button"
							aria-label={t`Select Item: ${pt.name}`}
							onClick={() => onSelectPermitType(pt.id, pt.name)}
							className={classNames(
								radioCardStyles({
									checked: false,
								}),
								"flex w-full cursor-pointer flex-row items-center px-4 py-3 hover:border-primary",
							)}
						>
							<div className="flex flex-1 flex-col gap-1 text-left">
								<Text As="span" weight="bold">
									{pt.name}
								</Text>
							</div>
							<AccessibleIcon>
								<ChevronRightIcon className="h-6 w-6 text-primary" />
							</AccessibleIcon>
						</button>
					</li>
				))}
				{registrationSettings.map((rs) => (
					<li key={`rs-${rs.id}`}>
						<button
							type="button"
							aria-label={t`Select Item: ${rs.name}`}
							onClick={() => onSelectRegistrationSetting(rs.id, rs.name)}
							className={classNames(
								radioCardStyles({
									checked: false,
								}),
								"flex w-full cursor-pointer flex-row items-center px-4 py-3 hover:border-primary",
							)}
						>
							<div className="flex flex-1 flex-col gap-1 text-left">
								<Text As="span" weight="bold">
									{rs.name}
								</Text>
							</div>
							<AccessibleIcon>
								<ChevronRightIcon className="h-6 w-6 text-primary" />
							</AccessibleIcon>
						</button>
					</li>
				))}
			</ul>
		</div>
	);
};
